<template>
  <div>
    <div
      style="
        width: 95%;
        max-width: 1518px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 11px;
        margin-top: 30px;
        background-color: white;
        padding: 30px 0 27px 0;
      "
      class="headerSearch"
    >
      <div style="width: 90%; margin-left: auto; margin-right: auto">
        <el-form
          :model="formInline"
          style="display: flex"
          class="demo-form-inline"
          label-width="90px"
          label-position="left"
        >
          <el-form-item label="姓名:">
            <el-input
              v-model="formInline.name"
              placeholder="请输入姓名"
            />
          </el-form-item>
          <el-form-item label="岗位:">
            <el-select
              v-model="formInline.zhiwu"
              clearable
              placeholder="请选择岗位"
            >
              <el-option
                v-for="item in yzd_cyry_zw"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="在职状态:">
            <el-select
              v-model="formInline.status"
              clearable
              placeholder="请选择在职状态"
            >
              <el-option
                v-for="item in yzd_zzzt"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-button
            v-preventReClick
            type="primary"
            icon="el-icon-search"
            round
            class="sousuoButton"
            @click="handleCurrentChange(1)"
          >查询</el-button>
        </el-form>
      </div>
    </div>
    <div
      style="
        width: 95%;
        max-width: 1518px;
        margin: 0 auto;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;
      "
      class="cyryTableContain"
    >
      <div style="width: 90%; margin-left: auto; margin-right: auto">
        <div class="tableXS">
          <div class="addmesbgc">
            <el-button
              v-preventReClick
              type="primary"
              icon="el-icon-plus"
              class="addmes"
              size="mini"
              @click="addMes(false)"
            >添加</el-button>
          </div>

          <el-table
            ref="filterTable"
            :data="tableData"
            style="width: 100%"
            border
            show-overflow-tooltip
            @selection-change="handleSelectionChange"
          >
            <el-table-column label="人员类型" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.cyrylxLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="姓名" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.xm }}</span>
              </template>
            </el-table-column>
            <el-table-column label="性别" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.xbLabel }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="身份证号"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.zjhm }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="手机号码" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.sjhm }}</span>
              </template>
            </el-table-column>
            <el-table-column label="岗位" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.gwLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="聘用时间" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.pysj }}</span>
              </template>
            </el-table-column>
            <el-table-column label="在职状态" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-if="
                    scope.row.cyrylx != '02' &&
                      (scope.row.zzzt == '0' || scope.row.zzzt == '1')
                  "
                  v-model="scope.row.zzzt"
                  :width="60"
                  :disabled="scope.row.cyrylx != '03'"
                  active-value="1"
                  inactive-value="0"
                  inactive-color="#666"
                  :class="{
                    'switch-is-actived': scope.row.zzzt == '0',
                  }"
                  @click.native="zzztchange1(scope.row.cyrylx)"
                  @change="zzztchange(scope.row.id, scope.row.zzzt, $event)"
                />
                <span
                  v-else
                  size="medium"
                  :style="{ color: scope.row.zzzt === '1' ? 'green' : 'red' }"
                >{{ scope.row.zzztLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200px" align="center">
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  size="mini"
                  type="primary"
                  icon="el-icon-view"
                  @click="handleSelect(scope.$index, scope.row, true)"
                >查看</el-button>
                <el-button
                  v-if="
                    scope.row.cyrylx != '02' &&
                      scope.row.zzzt != '0' &&
                      scope.row.zzzt != '2' &&
                      scope.row.zzzt != '3'
                  "
                  v-preventReClick
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row, true)"
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <cyry-dialog
      v-if="dialogFormVisible"
      ref="dialogcyry"
      :dialog-form-visible="dialogFormVisible"
      :cyrytype="type"
      :is-add="isAdd"
      @close-dialog="closeDialog"
    />
  </div>
</template>

<script>
// 获取接口地址
import {
  getcyryMes,
  getcyryDetailMes,
  getkv,
  changeztcyryMes
} from '@/assets/js/common.js'
import CyryDialog from './cyryDialog.vue'
export default {
  name: 'Cyry',
  components: { CyryDialog },
  data() {
    return {
      formInline: {
        name: '',
        zhiwu: '',
        status: ''
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0,
      dialogFormVisible: false, // 对话框的显示隐藏
      multipleSelection: [], // 多选选中数据
      type: false, // 添加和编辑，可编辑，查看不可编辑
      tableData: [],
      dataMes: {},
      yzd_cyry_zw: [],
      yzd_zzzt: [],
      isAdd: false
    }
  },
  created() {
    getkv('yzd_cyry_gw').then((e) => {
      this.yzd_cyry_zw = e.data.data
    })
    getkv('yzd_zzzt').then((e) => {
      this.yzd_zzzt = e.data.data
    })

    this.search()
  },
  methods: {
    // 从业人员列表信息
    getcyryMess(dataObj) {
      getcyryMes(dataObj).then((e) => {
        this.total = e.data.data.total
        this.tableData = e.data.data.rows
      })
    },
    zzztchange1(rylx) {
      // if (rylx != "03")
      //   this.$message.error("法人或信息员不能离职，请先移除相关身份！");
      if (rylx == '01' || rylx == '04') {
        this.$message.error('信息员不能离职，请主信息员先在【信息员】模块中移除其信息员身份！')
      } else if (rylx == '0') {
        this.$message.error('法人不能离职，请在【单位信息变更】模块中修改法人信息！')
      }
    },
    zzztchange(id, zzzt, val) {
      changeztcyryMes({ id: id, zzzt: zzzt }).then((e) => {})
    },
    // 点击搜索时
    search() {
      this.getcyryMess({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          xm: this.formInline.name,
          oneGw: this.formInline.zhiwu,
          zzzt: this.formInline.status
        }
      })
    },
    // 点击添加按钮
    addMes(isAdd) {
      this.isAdd = isAdd
      this.dialogFormVisible = true
      this.type = false
    },
    getcyryDetailMess(id) {
      getcyryDetailMes(id).then((e) => {
        this.dataMes = e.data.data
        this.$refs.dialogcyry.getformMes(this.dataMes)
      })
    },
    // 编辑
    handleEdit(index, row, isAdd) {
      this.dialogFormVisible = true
      this.type = false
      this.isAdd = isAdd
      this.getcyryDetailMess(row.id)
    },
    // 查看
    handleSelect(index, row, isAdd) {
      this.dialogFormVisible = true
      this.type = true
      this.isAdd = isAdd
      this.getcyryDetailMess(row.id)
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 关闭对话框
    closeDialog() {
      this.dialogFormVisible = false
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-switch.is-disabled {
  opacity: 1;
}
/deep/.el-switch.is-disabled .el-switch__core,
/deep/.el-switch.is-disabled .el-switch__label {
  cursor: pointer;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
.sousuoButton {
  width: 90px;
  height: 39px;
  background: #4170ff;
  // border-radius: 3px;
  border-color: #4170ff;
}
.el-button--primary {
  color: #fff;
  background-color: #4170ff;
  border-color: #4170ff;
}
/deep/ .el-pagination__total {
  margin-left: 8px;
}
.el-pagination {
  padding: 10px 0;
  border: 1px solid #ebeef5;
  border-top: 0;
}

.headerSearch {
  // border: 1px solid red;
  display: flex;
  align-items: center;
  // height: 96px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 11px;
  // padding-left: 82px;
  box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  .el-form-item {
    height: 39px;
    margin-bottom: 0px;
    margin-right: 30px;
    &:last-child {
      width: 90px;
      height: 39px;
      /deep/ .el-button {
        width: 90px !important;
        height: 39px;
        border-radius: 3px;
      }
    }
  }
}
.el-form-item__label {
  height: 41px;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}

.cyryTableContain {
  margin: 0 auto;

  .tableXS {
    //   width: 90%;
    // margin: 21px 0 57px 0;

    /deep/ .el-table {
      z-index: 0;
    }
    /deep/ .el-table .has-gutter tr th {
      background: #f4f4f4;
    }
    .addmesbgc {
      background: #f4f4f4;
      .addmes {
        margin: 15px;
      }
    }
  }
}
/deep/.el-switch {
  .el-switch__core {
    &::before {
      content: "在职";
      color: white;
      position: absolute;
      transform: scale(0.85);
      left: 10px;
    }
  }
  &.switch-is-actived {
    .el-switch__core {
      &::before {
        content: "离职";
        left: 21px;
        transform: scale(0.85);
      }
    }
  }
}
</style>
